var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReConnectedTemplate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link_off",
    clipPath: "url(#clip0_5419_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 7.5H13V9.4H17C18.71 9.4 20.1 10.79 20.1 12.5C20.1 13.93 19.12 15.13 17.79 15.48L19.25 16.94C20.88 16.11 22 14.45 22 12.5C22 9.74 19.76 7.5 17 7.5ZM16 11.5H13.81L15.81 13.5H16V11.5ZM2 4.77L5.11 7.88C3.29 8.62 2 10.41 2 12.5C2 15.26 4.24 17.5 7 17.5H11V15.6H7C5.29 15.6 3.9 14.21 3.9 12.5C3.9 10.91 5.11 9.6 6.66 9.43L8.73 11.5H8V13.5H10.73L13 15.77V17.5H14.73L18.74 21.5L20 20.24L3.27 3.5L2 4.77Z",
    fill: "#475467"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5419_2369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReConnectedTemplate);
export default __webpack_public_path__ + "static/media/reConnectedTemplate.a4247ab9ce232ea352eeaab2b11b17b8.svg";
export { ForwardRef as ReactComponent };